import Button from '../../common/Button';
import type { HeroProps } from './useHero';

const HeroDesktop = ({
  data,
  handlePrimaryClick,
  handleSecondaryClick,
}: HeroProps) => {
  return (
    <section className="relative h-[700px] w-full overflow-hidden pt-20">
      <img
        src={data.backgroundImage}
        alt="Hero background"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="bg-hero-overlay absolute inset-0" />

      <div className="relative flex h-full items-center">
        <div className="ml-20 flex w-[700px] flex-col gap-8">
          <h1 className="whitespace-pre-line font-heading text-[64px] font-medium italic leading-[1.1] text-foreground-inverse">
            {data.headline}
          </h1>
          <p className="max-w-[560px] whitespace-pre-line font-body text-lg leading-[1.6] text-foreground-inverse/80">
            {data.subtitle}
          </p>
          <div className="flex gap-4">
            <Button variant="primary" size="lg" onClick={handlePrimaryClick}>
              {data.ctaPrimary}
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={handleSecondaryClick}
              className="font-medium"
            >
              {data.ctaSecondary}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroDesktop;
